import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons/faBriefcase';
import { faChartPie } from '@fortawesome/free-solid-svg-icons/faChartPie';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons/faCircleInfo';
import { faCircleMinus } from '@fortawesome/free-solid-svg-icons/faCircleMinus';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons/faCirclePlus';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons/faCircleQuestion';
import { faCircleUser } from '@fortawesome/free-solid-svg-icons/faCircleUser';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons/faCalendarDays';
import { faComments } from '@fortawesome/free-regular-svg-icons/faComments';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons/faDollarSign';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faFileArrowDown } from '@fortawesome/free-solid-svg-icons/faFileArrowDown';
import { faFileLines } from '@fortawesome/free-regular-svg-icons/faFileLines';
import { faGasPump } from '@fortawesome/free-solid-svg-icons/faGasPump';
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons/faGraduationCap';
import { faHouse } from '@fortawesome/free-solid-svg-icons/faHouse';
import { faImage } from '@fortawesome/free-regular-svg-icons/faImage';
import { faLaptop } from '@fortawesome/free-solid-svg-icons/faLaptop';
import { faLightbulb } from '@fortawesome/free-regular-svg-icons/faLightbulb';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faMap } from '@fortawesome/free-regular-svg-icons/faMap';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons/faMicrophone';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faMobileScreenButton } from '@fortawesome/free-solid-svg-icons/faMobileScreenButton';
import { faNewspaper } from '@fortawesome/free-regular-svg-icons/faNewspaper';
import { faPencil } from '@fortawesome/free-solid-svg-icons/faPencil';
import { faPeopleGroup } from '@fortawesome/free-solid-svg-icons/faPeopleGroup';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint';
import { faRotate } from '@fortawesome/free-solid-svg-icons/faRotate';
import { faRss } from '@fortawesome/free-solid-svg-icons/faRss';
import { faSquareCheck } from '@fortawesome/free-regular-svg-icons/faSquareCheck';
import { faSquareFacebook } from '@fortawesome/free-brands-svg-icons/faSquareFacebook';
import { faSquareRss } from '@fortawesome/free-solid-svg-icons/faSquareRss';
import { faSquareXTwitter } from '@fortawesome/free-brands-svg-icons/faSquareXTwitter';
import { faSquareYoutube } from '@fortawesome/free-brands-svg-icons/faSquareYoutube';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons/faTrashCan';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons/faTriangleExclamation';
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faCartShopping } from '@fortawesome/free-solid-svg-icons/faCartShopping';

library.add(
  faBriefcase,
  faChartPie,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleInfo,
  faCircleMinus,
  faCirclePlus,
  faCircleQuestion,
  faCircleUser,
  faCalendarDays,
  faComments,
  faDollarSign,
  faDownload,
  faEnvelope,
  faFileArrowDown,
  faFileLines,
  faGasPump,
  faGoogle,
  faGraduationCap,
  faHouse,
  faImage,
  faLaptop,
  faLightbulb,
  faLock,
  faMap,
  faMicrophone,
  faMinus,
  faMobileScreenButton,
  faNewspaper,
  faPencil,
  faPeopleGroup,
  faPlus,
  faPrint,
  faRotate,
  faRss,
  faSquareCheck,
  faSquareFacebook,
  faSquareRss,
  faSquareXTwitter,
  faSquareYoutube,
  faTrashCan,
  faTriangleExclamation,
  faTruck,
  faUser,
  faUsers,
  faWrench,
  faXmark,
  faYoutube,
  faCartShopping,
);

dom.watch();
